export default __webpack_public_path__ + "static/media/diamond-color-3@3x.6af32c88.png";